export default function ThemePreview() {
  const themes = [
    {
      id: 1,
      label: "Tryb 1 — Klasyczne Złoto",
      sub: "Obecny styl · tło granatowo-czarne · akcent złoto #d4af37",
      emoji: "🪦",
      img: "/images/mockup_theme1_gold_20260420_195004.png",
      badge: "#d4af37",
    },
    {
      id: 2,
      label: "Tryb 2 — Nowoczesna Młodzież",
      sub: "Tło ciemny fiolet · akcent żywy fiolet #7c3aed · cyfrowy, energetyczny",
      emoji: "💜",
      img: "/images/mockup_theme2_youth_20260420_195004.png",
      badge: "#7c3aed",
    },
    {
      id: 3,
      label: "Tryb 3 — Gaming",
      sub: "Tło czysta czerń + hex grid · akcent neonowy cyan #00d4ff · cyberpunk",
      emoji: "🎮",
      img: "/images/mockup_theme3_gaming_v2_20260420_195025.png",
      badge: "#00d4ff",
    },
    {
      id: 4,
      label: "Tryb 4 — Ciepła Neutralna",
      sub: "Tło ciemny grafit/sepia · akcent bursztyn #c87941 · ziemisty, klimatyczny",
      emoji: "🍂",
      img: "/images/mockup_theme4_neutral_20260420_195005.png",
      badge: "#c87941",
    },
    {
      id: 5,
      label: "Tryb 5 — Mroczna Powaga",
      sub: "Tło absolutna czerń · akcent burgund #8b0000 · gotycki, surowy",
      emoji: "🖤",
      img: "/images/mockup_theme5_darkest_20260420_195008.png",
      badge: "#8b0000",
    },
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#0a0c18", padding: "40px 24px", fontFamily: "Inter, sans-serif" }}>
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: 48 }}>
        <p style={{ color: "rgba(212,175,55,0.5)", fontSize: 11, letterSpacing: "0.3em", textTransform: "uppercase", marginBottom: 12 }}>
          e-grób · podgląd trybów kolorystycznych
        </p>
        <h1 style={{ color: "rgba(212,175,55,0.9)", fontSize: 32, fontFamily: "'Playfair Display', serif", fontWeight: 700, margin: 0 }}>
          5 Motywów Wizualnych
        </h1>
        <p style={{ color: "rgba(140,155,175,0.6)", fontSize: 14, marginTop: 10 }}>
          Wybierz motyw który najbardziej Ci odpowiada — po akceptacji zostanie zaimplementowany jako przełącznik w ustawieniach
        </p>
        <div style={{ width: 80, height: 1, background: "linear-gradient(to right, transparent, rgba(212,175,55,0.4), transparent)", margin: "20px auto 0" }} />
      </div>

      {/* Grid makiet */}
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", flexDirection: "column", gap: 56 }}>
        {themes.map((t) => (
          <div key={t.id} style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {/* Nagłówek motywu */}
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 16 }}>
              <div style={{
                width: 40, height: 40, borderRadius: 12,
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 20,
              }}>
                {t.emoji}
              </div>
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <h2 style={{ color: "#fff", fontSize: 18, fontWeight: 600, margin: 0 }}>{t.label}</h2>
                  <div style={{
                    width: 14, height: 14, borderRadius: "50%",
                    background: t.badge,
                    boxShadow: `0 0 8px ${t.badge}88`,
                    flexShrink: 0,
                  }} />
                  <code style={{
                    fontSize: 11, padding: "2px 8px", borderRadius: 6,
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    color: "rgba(180,195,215,0.7)",
                  }}>{t.badge}</code>
                </div>
                <p style={{ color: "rgba(140,155,175,0.6)", fontSize: 13, margin: "4px 0 0" }}>{t.sub}</p>
              </div>
            </div>

            {/* Makieta */}
            <div style={{
              borderRadius: 16,
              overflow: "hidden",
              border: "1px solid rgba(255,255,255,0.07)",
              boxShadow: `0 8px 40px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.03)`,
              position: "relative",
            }}>
              {/* Pasek przeglądarki */}
              <div style={{
                background: "#1a1b26",
                padding: "10px 16px",
                display: "flex", alignItems: "center", gap: 8,
                borderBottom: "1px solid rgba(255,255,255,0.05)",
              }}>
                <div style={{ display: "flex", gap: 6 }}>
                  {["#ff5f57", "#febc2e", "#28c840"].map((c, i) => (
                    <div key={i} style={{ width: 12, height: 12, borderRadius: "50%", background: c }} />
                  ))}
                </div>
                <div style={{
                  flex: 1, margin: "0 12px", height: 24, borderRadius: 6,
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  display: "flex", alignItems: "center", paddingLeft: 10,
                }}>
                  <span style={{ color: "rgba(140,155,175,0.5)", fontSize: 11 }}>e-grob.pl</span>
                </div>
              </div>

              {/* Obrazek makiety */}
              <img
                src={t.img}
                alt={t.label}
                style={{ width: "100%", display: "block" }}
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div style={{ textAlign: "center", marginTop: 64, paddingBottom: 40 }}>
        <div style={{ width: 80, height: 1, background: "linear-gradient(to right, transparent, rgba(212,175,55,0.3), transparent)", margin: "0 auto 20px" }} />
        <p style={{ color: "rgba(100,115,135,0.5)", fontSize: 12 }}>
          Po akceptacji motywów zostanie wdrożony przełącznik w menu ustawień (≡) w prawym górnym rogu
        </p>
      </div>
    </div>
  );
}
